import { render, staticRenderFns } from "./checkoutV2Two.vue?vue&type=template&id=4c2574cb&scoped=true"
import script from "./checkoutV2Two.vue?vue&type=script&lang=js"
export * from "./checkoutV2Two.vue?vue&type=script&lang=js"
import style0 from "./checkoutV2Two.vue?vue&type=style&index=0&id=4c2574cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2574cb",
  null
  
)

export default component.exports